import styled from 'styled-components';
import { P, A } from 'components/Typography';
import { sizes } from 'style';
import { th } from 'style/theme';

export const Background = styled.div`
  max-width: 1000px;
  padding: 40px;
  margin: 0 auto;
  border-radius: 40px;
  background-color: ${th('colors.jaggedIce')};
  color: ${th('colors.black')};
  box-shadow: 0px 8px 32px 0px #0f172a14;

  @media ${sizes.tabletPortrait} {
    padding: 40px 48px;
  }
`;

export const UpdatedOn = styled(P)`
  margin: 20px 0;
  font-size: 14px;
  color: ${th('colors.black')};
`;

export const Section = styled.div`
  position: relative;
  margin-top: 30px;

  :not(:last-child) {
    padding-bottom: 18px;
    margin-bottom: 30px;

    :after {
      content: ' ';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background-color: #a0dede;
    }
  }
`;

export const Heading = styled.div`
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.02%;
  font-family: Inter, sans-serif;
`;

export const SubHeader = styled.h4`
  font-size: 16px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.02%;
  margin: 16px 0 0 0;
  font-family: Inter, sans-serif;
`;

export const Paragraph = styled(P)`
  font-family: Inter;
  color: ${th('colors.black')};
  margin: 12px 0;
  line-height: 24px;
  letter-spacing: -0.01em;
  font-weight: 400;
  font-size: 16px;
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  border-radius: 20px;
  margin: 20px 0;
  background-color: #7dd1d2;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.01em;
  font-weight: 400;
  @media ${sizes.tabletPortrait} {
    flex-direction: row;
    gap: 32px;
  }
`;

export const BoxColumn = styled.div`
  :first-of-type {
    @media ${sizes.tabletPortrait} {
      width: 40%;
      flex-shrink: 0;
    }
    @media ${sizes.desktop} {
      width: 300px;
    }
  }
  > b:not(:first-child) {
    display: block;
    margin-top: 16px;
  }
`;

export const BoxColumnValue = styled(P)`
  margin-top: 4px;
  line-height: 26px;
  color: ${th('colors.black')};
`;

export const List = styled.ul`
  padding: 0;
  margin: 0;
  margin-top: 4px;
  margin-bottom: 16px;
  line-height: 26px;

  > li {
    margin-left: 20px;
  }
`;

export const Asterisk = styled.div`
  margin-top: 24px;
  font-size: 14px;
  line-height: 24px;
`;

export const Email = styled(A)`
  color: #339394;
  text-decoration: none;
  :hover {
    color: #33939490;
  }
`;
